import { createClient } from '@/lib/supabase/browser'

export async function getOrCreateDirectConversation(
  supabase: ReturnType<typeof createClient>,
  user1Id: string,
  user2Id: string
): Promise<string> {
  console.log('[DM] Calling create_direct_conversation RPC', user1Id, user2Id)

  const { data, error } = await supabase
    .rpc('create_direct_conversation', {
      p_user1_id: user1Id,
      p_user2_id: user2Id,
    })

  if (error) {
    console.error('[DM] RPC error:', JSON.stringify(error))
    throw new Error(error.message || 'Could not create conversation')
  }

  if (!data) {
    throw new Error('No conversation ID returned')
  }

  console.log('[DM] Conversation ID:', data)
  return data as string
}
